import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Trash2, Mail } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

export default function AdminContact() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  const { toast } = useToast();

  const load = () => api.admin.contacts().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this enquiry?')) return;
    await api.admin.contactDelete(id);
    setOpen(null);
    toast({ title: 'Deleted' });
    load();
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-extrabold">Contact enquiries</h1>
        <p className="text-gray-500 text-sm mt-1">{rows.length} messages from users</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map(r => (
          <div key={r.id} className="bg-white p-5 rounded-2xl border border-gray-200 hover:shadow-md transition-shadow cursor-pointer" onClick={() => setOpen(r)}>
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center gap-2">
                <Mail size={16} className="text-[#6b47dc]" />
                <span className="font-bold">{r.name}</span>
              </div>
              <span className="text-[10px] text-gray-400">{r.createdAt ? new Date(r.createdAt).toLocaleDateString() : ''}</span>
            </div>
            <div className="text-xs text-gray-500 mb-2">{r.email} {r.phone && <>• {r.phone}</>}</div>
            {r.course && <div className="text-xs text-[#6b47dc] font-semibold mb-2">Interested in: {r.course}</div>}
            <p className="text-sm text-gray-700 line-clamp-3">{r.message}</p>
          </div>
        ))}
        {rows.length === 0 && <div className="col-span-full text-center py-12 text-gray-400">No enquiries yet</div>}
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/50 z-50 grid place-items-center p-4" onClick={() => setOpen(null)}>
          <div className="bg-white rounded-2xl max-w-lg w-full p-6" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-extrabold text-xl mb-1">{open.name}</h3>
            <div className="text-sm text-gray-500 mb-4">{open.email} {open.phone && <>• {open.phone}</>}</div>
            {open.course && <div className="mb-2 text-sm"><span className="font-semibold">Interested course: </span>{open.course}</div>}
            <div className="bg-gray-50 rounded-lg p-4 text-sm mb-4 whitespace-pre-wrap">{open.message}</div>
            <div className="flex justify-between">
              <a href={`mailto:${open.email}`} className="text-sm font-semibold text-[#6b47dc] hover:underline">Reply via email</a>
              <button onClick={() => remove(open.id)} className="text-sm text-red-600 flex items-center gap-1"><Trash2 size={14} /> Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
